<div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title" style="line-height:1.2;">
				<strong>Számlázási periódus</strong><br />
				<small class="text-light"><%- Anvil.moment(period.start_d).format('YYYY. MMMM') %><% if (period.months > 1) { %> - <%- Anvil.moment(period.end_d).format('YYYY. MMMM') %><% } %> (<%- period.months %> hónap)</small>

				<!--
				<strong><%= company.name %></strong><br />
				<small class="text-info" style="font-size:0.7em; font-weight:normal;"><%= company.tax_number %></small>
				-->
			</h5>
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
		</div>
		<div class="modal-body p-0">
			<div class="container">
				<div class="row">
					<div class="col p-0">

						<ul class="nav nav-pills m-2">
							<li class="nav-item">
								<button type="button" class="nav-link active" data-bs-toggle="tab" data-bs-target="#invoicing-tab-customer"><i class="fa fa-user me-lg-2"></i><span class="d-none d-lg-inline">Vevő</span></button>
							</li>
							<li class="nav-item">
								<button type="button" class="nav-link" data-bs-toggle="tab" data-bs-target="#invoicing-tab-items"><i class="fa fa-list me-lg-2"></i><span class="d-none d-lg-inline">Tételek (<%- invoice_form.items.length %>)</span></button>
							</li>
							<li class="nav-item">
								<button type="button" class="nav-link" data-bs-toggle="tab" data-bs-target="#invoicing-tab-preview" onclick="Anvil.page.modal.preview();"><i class="fa fa-print me-lg-2"></i><span class="d-none d-lg-inline">Előnézet</span></button>
							</li>

							<li class="flex-grow-1 text-end">
								<% if (has_invoice) { %><div class="badge bg-danger me-1 p-2" style="animation:flash 1s infinite;">Már számláztunk a<br />periódus kezdete óta!</div><% } %>
							</li>

							<li class="nav-item">
								<button type="button" class="nav-link" data-bs-toggle="tab" data-bs-target="#invoicing-tab-history"><i class="fas fa-history me-lg-2"></i><span class="d-none d-lg-inline">Számla történet</span></button>
							</li>
						</ul>

						<hr class="m-0" />

						<div class="tab-content" style="height:100vh; max-height:calc(100vh - 255px); overflow-y:auto;">

							<div class="tab-pane p-3 show active" id="invoicing-tab-customer" tabindex="0">
								<div class="row g-3">
									<div class="col col-lg-7">
										<%- include('/ui/form', {
											params: [ 'invoice_customer', invoice_form, {
												label_width: 3
											} ],
											fields: [
												{ type: 'row', fields: [
													{ type: 'col', fields: [
														{
															type: 'text',
															name: 'customer_name',
															title: 'Vevő neve'
														}
													]}
												]},
												{ type: 'row', fields: [
													{ type: 'col', fields: [
														{
															type: 'html',
															content: `<h5 class="my-3" style="border-bottom:1px dashed #666;">Cím</h5>`
														},
														{
															type: 'text',
															name: 'customer_country',
															title: 'Ország',
														},
														{
															type: 'text',
															name: 'customer_area_code',
															title: 'Irányítószám'
														},
														{
															type: 'text',
															name: 'customer_city',
															title: 'Település'
														},
														{
															type: 'text',
															name: 'customer_address',
															title: 'Utca, házszám'
														}
													]}
												]},
												{ type: 'row', fields: [
													{ type: 'col', fields: [
														{
															type: 'html',
															content: `<h5 class="my-3" style="border-bottom:1px dashed #666;">Adó azonosítás</h5>`
														},
														{
															type: 'select',
															no_keyboard: true,
															name: 'customer_tax_type',
															title: 'Típus',
															options: [],
															params: {
																maxItems: 1,
																options: [
																	{ value: 'DOMESTIC', label: 'Belföldi ÁFA alany', info: '(belföldi vállalkozás, cég, stb. ami rendelkezik magyar adószámmal)' },
																	{ value: 'PRIVATE_PERSON', label: 'Természetes személy', info: '(magánszemély)' },
																	{ value: 'OTHER', label: 'Egyéb', info: '(külföldi, magyar adószámmal nem rendelkező cégek)' }
																],
																valueField: 'value',
																labelField: 'label',
																render: {
																	item: (item, esc) => `<div>${item.label}</div>`,
																	option: (item, esc) => `<div class="option">${item.label}<br /><small class="text-dim ps-1" style="font-weight:normal;">${item.info}</small></div>`
																}
															}
														},
														{
															type: 'text',
															name: 'customer_tax_number',
															title: 'Adószám'
														},
														/*
														{
															type: 'text',
															name: 'customer_group_tax_number',
															title: 'Csop. adószám'
														},
														{
															type: 'text',
															name: 'customer_eu_tax_number',
															title: 'EU adószám'
														}
														*/
													]}
												]},
												{ type: 'row', fields: [
													{ type: 'col', fields: [
														{
															type: 'html',
															content: `<h5 class="my-3" style="border-bottom:1px dashed #666;">E-mail</h5>`
														},
														{
															type: 'group',
															title: 'E-mail',
															fields: [
																{
																	type: 'text',
																	name: 'customer_email',
																	title: 'E-mail cím',
																},
																{
																	type: 'checkbox',
																	name: 'send_email',
																	title: 'E-mail küldés',
																	description: 'Számla küldése e-mailben'
																}
															]
														}
													]}
												]}
											]
										}) %>
									</div>
									<div class="col col-lg-5">
										<%- include('/ui/form', {
											params: [ 'invoice_head', invoice_form, {
												width: 400,
												label_width: 5
											} ],
											fields: [
												{ type: 'row', fields: [
													{ type: 'col', fields: [
														{
															type: 'select',
															no_keyboard: true,
															name: 'invoice_currency',
															title: 'Pénznem',
															options: [],
															params: {
																maxItems: 1,
																options: [
																	{ value: 'HUF', label: 'Forint (HUF)' },
																	{ value: 'EUR', label: 'Euró (EUR)' },
																],
																valueField: 'value',
																labelField: 'label',
																render: {
																	item: (item, esc) => `<div>${item.label}</div>`,
																	option: (item, esc) => `<div class="option">${item.label}</div>`
																}
															},
															attributes: {
																disabled: true
															}
														},
													]}
												]},
												{ type: 'row', fields: [
													{ type: 'col', fields: [
														{
															type: 'html',
															content: `<h5 class="my-3" style="border-bottom:1px dashed #666;">Számla adatok</h5>`
														},
														{
															type: 'date',
															name: 'invoice_d',
															title: 'Kelt',
															attributes: {
																disabled: true
															}
														},
														{
															type: 'date',
															name: 'invoice_complete_d',
															title: 'Teljesítés'
														},
														/*
														{
															type: 'select',
															no_keyboard: true,
															name: 'invoice_payment_method',
															title: 'Fizetési mód',
															options: [],
															params: {
																maxItems: 1,
																options: payment_methods.data,
																valueField: 'id',
																labelField: 'name_hu',
																render: {
																	item: (item, esc) => `<div>${item[`name_${Anvil.lang.language.db_code}`] || item.name_hu}</div>`,
																	option: (item, esc) => `<div class="option">${item[`name_${Anvil.lang.language.db_code}`] || item.name_hu}</div>`
																}
															}
														},
														*/
														{
															type: 'date',
															name: 'invoice_payment_d',
															title: 'Fizetési határidő'
														}
													]}
												]}
											]
										}) %>
									</div>
								</div>
							</div>

							<div class="tab-pane p-3" id="invoicing-tab-items" tabindex="0">
								<%- include('/ui/grid', {
									list: { data: invoice_form.items },
									name: 'invoice_items',
									params: {
										height: 'calc(100vh - 290px)',
										row_height: 48,
										columns: [
											{
												title: '',
												field: 'offset',
												sort: false,
												type: {
													render (value, row, options, map, offset) {
														return `<input type="checkbox" id="invoice_item_selected_${offset}" value="${row.id}" ${row.include ? `checked="true"` : ''} onchange="Anvil.page.modal.invoice_form.items[${offset}].include = $('#invoice_item_selected_${offset}').get(0).checked" style="width:26px; height:26px; margin:6px;" />`
													}
												},
												width: 48
											},
											{
												title: 'Megnevezés',
												field: 'name',
												sort: false,
												type: {
													render (value, row, options, map, offset) {
														return `
															${value}${row.mediated_service ? ' <div class="badge bg-primary">K.Sz.</div>': ''}<br />
															<small class="text-info">${row.comment}</small>`
													}
												},
												width: 360
											},
											{
												title: 'Mennyiség',
												field: 'quantity',
												sort: false,
												type: {
													render (value, row, options) {
														return Anvil.numeral(value).format('0,0.[00]')
													}
												},
												options: {
													class: 'text-end'
												},
												width: 100
											},
											{
												title: 'M.e.',
												field: 'unit',
												sort: false,
												type: 'string',
												width: 60
											},
											{
												title: 'Nettó egys.',
												field: 'unit_price_net',
												sort: false,
												type: {
													render (value, row, options) {
														return Anvil.numeral(value).format('0,0.[00]')
													}
												},
												options: {
													class: 'text-end text-gold'
												},
												width: 110
											},
											{
												title: 'Bruttó egys.',
												field: 'unit_price_gross',
												sort: false,
												type: {
													render (value, row, options) {
														return Anvil.numeral(value).format('0,0.[00]')
													}
												},
												options: {
													class: 'text-end text-gold'
												},
												width: 110
											},
											{
												title: 'Nettó érték',
												field: 'price_net',
												sort: false,
												type: {
													render (value, row, options) {
														return Anvil.numeral(value).format('0,0.[00]')
													}
												},
												options: {
													class: 'text-end text-gold'
												},
												width: 120
											},
											{
												title: 'Áfa %',
												field: 'vat',
												sort: false,
												type: {
													render (value, row, options) {
														return Anvil.numeral(value / 100).format('%')
													}
												},
												options: {
													class: 'text-end'
												},
												width: 60
											},
											{
												title: 'Bruttó érték',
												field: 'price_gross',
												sort: false,
												type: {
													render (value, row, options) {
														return Anvil.numeral(value).format('0,0.[00]')
													}
												},
												options: {
													class: 'text-end text-gold'
												},
												width: 120
											}
										]
									}
								}) %>
							</div>

							<div class="tab-pane p-0" id="invoicing-tab-preview" tabindex="0">
								<%- include('modal_invoicing_preview', { pdf_data: null, loading: false }) %>
							</div>

							<div class="tab-pane p-3" id="invoicing-tab-history" style="height:100%;" tabindex="0">

								<%
								const get_rel = (map, offset, parent_key, child_key) => {

									const parent_val = (row) => {
										if (Array.isArray(parent_key)) {
											return parent_key.map(k => row[k]).join('_')
										} else {
											return row[parent_key]
										}
									}

									const prev_row = map[offset - 1] || false
									const row = map[offset]
									const next_row = map[offset + 1] || false

									const parent = parent_val(row)
									const self = row[child_key]

									const pd = !prev_row || (self !== prev_row[child_key]) || (parent !== parent_val(prev_row))	// previous line is different
									const nd = !next_row || (self !== next_row[child_key]) || (parent !== parent_val(next_row))	// next line is different

									var fc = true	// this is the first child
									for (let o = offset; o >= 0; o--) {
										if (parent_val(map[o]) != parent) break
										if (map[o][child_key] != self) {
											fc = false
											break
										}
									}
									var lc = true	// this is the last child
									for (let o = offset; o < map.length; o++) {
										if (parent_val(map[o]) != parent) break
										if (map[o][child_key] != self) {
											lc = false
											break
										}
									}

									if (fc && lc && pd) return { p:true, b:false, d:true }
									else if (fc && pd) return { p:true, b:true, d:true }
									else if (!pd && !lc) return { p:false, b:true, d:false }
									else if (pd && !lc) return { p:false, b:true, d:true }
									else if (pd && lc) return { p:false, b:false, d:true }
									else return { p:false, b:false, d:false }
								}
								%>

								<%- include('/ui/grid', {
									list: { data: invoice_history },
									name: 'invoice_history',
									params: {
										height: 'calc(100vh - 290px)',
										row_height: 60,
										row_class: (row) => {
											if (row.stornoed) return 'bg-dark text-dim'
											return ''
										},
										columns: [
											{
												title: 'Kiállítva',
												field: 'invoice_d',
												type: {
													render (value, row, options, map, offset) {
														const prev_row = map[offset - 1] || undefined
														const next_row = map[offset + 1] || undefined

														if (row.invoice_id === null) return ''
														if (row.invoice_id !== (prev_row && prev_row.invoice_id)) {
															return `
																<div class="cel_title">
																	<div class="cel_title_text">${Anvil.moment(value).format('YYYY. MM. DD.')}</div>
																</div>
																${(row.stornoed) ? `<div class="badge bg-info"><strong>Sztornózva</strong></div>` : ''}
																`
														} else {
															return ''
														}
													}
												},
												width: 120
											},
											{
												title: 'Számla sorszám',
												field: 'invoice_nr',
												type: {
													render (value, row, options, map, offset) {
														const prev_row = map[offset - 1] || undefined
														const next_row = map[offset + 1] || undefined

														if (row.invoice_id === null) return ''
														if (row.invoice_id !== (prev_row && prev_row.invoice_id)) {
															return `
																<div class="cel_title">
																	<div class="cel_title_text">${value}</div>
																</div>
																<small>${row.invoice_remark}</small>
																`
														} else {
															return ''
														}
													}
												},
												width: 330
											},
											{
												title: 'Tétel megnevezése',
												field: 'product',
												type: {
													render (value, row, options, map, offset) {
														const rel = get_rel(map, offset, 'invoice_id', 'item_id')
														const prefix = `<div class="rel${rel.p ? ' r_parent' : ''}${rel.b ? ' r_branch' : ''}${rel.d ? ' r_display' : ''}"></div>`
														if (rel.d) {
															return prefix + `
																<div class="cel_title">
																	<div class="cel_title_text"><strong>${row.quantity}</strong> <span class="text-dim">&times;</span> ${row.product}</div>
																</div>
																<small class="text-muted">${row.remark || '&nbsp;'}</small>
																`
														} else {
															return prefix
														}
													}
												},
												options: {
													class: 'cel_rel cel_rel_narrow'
												},
												width: 500
											},
											{
												title: 'Nettó',
												field: 'net',
												type: {
													render (value, row, options) {

														const colors = (row.stornoed) ? 'text-dim' :
																	(row.paid_amount > row.gross_total) ? 'bg-info text-light' :
																	(row.paid_amount == row.gross_total) ? 'bg-success text-light' :
																	(Anvil.moment(row.deadline_d).isBefore()) ? 'bg-danger text-light' :
																	(row.paid_amount > 0) ? 'bg-warning text-light' : 'bg-dark text-light'

														return `
															<div class="cel_title">
																<div class="cel_title_text ${colors}">${Anvil.numeral(parseFloat(row.net)).format('0,0.[00]')}</div>
															</div>
															${(!row.stornoed && row.paid_amount > 0 && row.paid_amount < row.gross_total) ? `<div class="badge bg-warning text-light">Fizetve: ${Anvil.numeral(row.paid_amount / row.gross_total).format('%')}</div>` : ''}
															${(!row.stornoed && row.paid_amount > 0 && row.paid_amount > row.gross_total) ? `<div class="badge bg-info text-light"></div>Túlfizetés: ${Anvil.numeral(row.paid_amount - row.gross_total).format('0,0.[00]')}` : ''}
															`
													}
												},
												options: { class: 'text-end text-gold' },
												width: 140
											},
											/*
											{
												title: 'Bruttó',
												field: 'gross',
												type: 'number',
												width: 120
											}
											*/
										]
									}
								}) %>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" onclick="Anvil.page.modal.issue(true)"><i class="fa fa-check me-2"></i>Piszkozat készítése</button>
			<button type="button" class="btn btn-primary" onclick="Anvil.page.modal.issue(false)"><i class="fa fa-check me-2"></i>Számla kiállítása</button>
		</div>
	</div>
</div>
<script>
Anvil.page.modal = Object.assign(Anvil.page.modal, {

	async preview () {
        try {
            const invoice_form = Anvil.page.modal.invoice_form
			const size = invoice_form.format

            if (invoice_form.record.validate()) {

                // Előnézet betöltése animáció
                await Anvil.render('company/modal_invoicing_preview', { size, document: null, loading: true }, '#invoicing-tab-preview')

                // Elküldjük a felhőnek a számla adatokat, hogy generálja le a PDF-et
                invoice_form.action = 'preview'
                const res = await invoice_form.record.commit()

                if (res.success) {
                    if (res.error) {
                        // Szerver oldali validációs vagy egyéb számla adat hiba

                        // Hibaüzenetek összefűzése
                        const messages = Array.isArray(res.error) ? res.error.reduce((acc, cur) => {
                            acc.push(cur.error)
                            return acc
                        }, []).join('<br />') : 'Ismeretlen hiba történt.'

                        // Szerver oldali validációs vagy egyéb számla adat hiba
                        Anvil.toast.error('Hiba!', messages)
                        return
                    }

					Anvil.page.modal.document = {
						data: res.pdf,
						size,
						mime_type: (size == '80' ? 'text/html' : 'application/pdf')
					}

					if (Anvil.page.modal.document.size == '80') {

						// Base64 decode the document data
						const data = await Anvil.render('cloud/80strip', { content: Buffer.from(Anvil.page.modal.document.data, 'base64').toString('utf8') }, '')

						// Előnézet megjelenítése
						await Anvil.render('company/modal_invoicing_preview', { size, document: Object.assign({}, Anvil.page.modal.document, { data: Buffer.from(data, 'utf8').toString('base64') }), loading: false }, '#invoicing-tab-preview')

					} else {

						// Előnézet megjelenítése
						await Anvil.render('company/modal_invoicing_preview', { size, document: Anvil.page.modal.document, loading: false }, '#invoicing-tab-preview')
					}
                }
            } else {

                // Validációs hiba
                await Anvil.render('company/modal_invoicing_preview', { size, document: null, loading: false }, '#invoicing-tab-preview')
            }
        } catch (err) {
            // Nem várt hiba történt, a kérés sikertelen
            console.error(err)
        }
    },

	async issue (draft = true) {

		const res = await Anvil.exec('company/issue_invoice', Anvil.page.modal.invoice_form, draft)

		if (res === true) {

			// Refresh list
			if ('refresh' in Anvil.page) {
				Anvil.page.refresh()
			}

			// Close modal
			Anvil.page.modal.close()
		}
	}
})
</script>
